import React, {useState} from "react";
import PropTypes from "prop-types";

import GoogleAddressAutocomplete from "../../../components/GoogleAddressAutocomplete";
import {useAccommodationsPage} from "../AccommodationContext";

import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField/TextField";
import Stack from "@mui/material/Stack";
import MenuItem from "@mui/material/MenuItem";


const StepAddress = (props) => {
    const {formik} = props
    const {locations} = useAccommodationsPage();
    const [address, setAddress] = useState(null);

    const handleAddressChange = (address) => {
        setAddress(address)

        const {street, streetNumber, city} = address;
        formik.setFieldValue("addressStreet", street || "");
        formik.setFieldValue("addressNumber", streetNumber || "");
        formik.setFieldValue("addressCity", city || "");
    }

    return <Stack direction="column" spacing={3} sx={{mt: 1}}>
        <TextField
            required
            name="name"
            value={formik.values.name}
            onChange={formik.handleChange}
            error={formik.touched.name && Boolean(formik.errors.name)}
            helperText={formik.touched.name && formik.errors.name}
            label="Nome casa"
            fullWidth
        />

        <TextField
            select
            required
            name="locationId"
            value={formik.values.locationId}
            onChange={formik.handleChange}
            error={formik.touched.locationId && Boolean(formik.errors.locationId)}
            helperText={formik.touched.locationId && formik.errors.locationId}
            label="Località"
            fullWidth >
            {
                locations.map(({id, name}) => (
                    <MenuItem key={id} value={id}>{name}</MenuItem>
                ))
            }
        </TextField>

        <GoogleAddressAutocomplete onAddressChange={handleAddressChange}/>

        {
            (address || formik.values.addressStreet || formik.values.addressNumber || formik.values.addressCity) && <>
                <Typography variant="body1">Conferma indirizzo:</Typography>
                <TextField label="Via"
                           fullWidth
                           size="small"
                           name="addressStreet"
                           value={formik.values.addressStreet}
                           onChange={formik.handleChange}
                           error={formik.touched.addressStreet && Boolean(formik.errors.addressStreet)}
                           helperText={formik.touched.addressStreet && formik.errors.addressStreet}/>

                <TextField label="Numero civico"
                           fullWidth
                           size="small"
                           name="addressNumber"
                           value={formik.values.addressNumber}
                           onChange={formik.handleChange}
                           error={formik.touched.addressNumber && Boolean(formik.errors.addressNumber)}
                           helperText={formik.touched.addressNumber && formik.errors.addressNumber}/>

                <TextField label="Città"
                           fullWidth
                           size="small"
                           value={formik.values.addressCity}/>
            </>
        }
    </Stack>
}

StepAddress.propTypes = {
    formik: PropTypes.object.isRequired
};

export default StepAddress;